import { ShopType } from '@entities/Shop';

export const sortByFieldSort = (a, b) => a.sort - b.sort;
export const sortByDistance = (a, b) => a.distance - b.distance;
export const sortPartner = (a: ShopType, b: ShopType): number => {
  return a.partner - b.partner;
};

export const sortByStatusDeliveryToday = (a: ShopType, b: ShopType): number => {
  return a.statusDeliveryToday - b.statusDeliveryToday;
};

export const sortByStatusDeliveryNoToday = (a: ShopType, b: ShopType): number => {
  return a.statusDeliveryNoToday - b.statusDeliveryNoToday;
};

export const sortByQuantityToday = (a: ShopType, b: ShopType): number => {
  if (a.quantityToday && b.quantityToday) {
    return b.quantityToday - a.quantityToday;
  }

  return 0;
};

export const sortByQuantityNoToday = (a: ShopType, b: ShopType): number => {
  if (a.quantityNoToday && b.quantityNoToday) {
    return b.quantityNoToday - a.quantityNoToday;
  }

  return 0;
};
